import React, { Component } from "react";
import Link from "gatsby-link";
import "./_nav.scss";

class Nav extends Component {
  render() {
    return (
      <nav className="nav">
        <div className="nav__row">
          <h1 className="nav__heading">
            <Link to="/">AfroSoc</Link>
          </h1>
          <h1 className="nav__subheading">
            <Link to="/">Afrosocialists and Socialists of Color Caucus</Link>
          </h1>
          <div className="nav__menu">
            <h2 className="nav__menu-item">
              <Link to="/">Home</Link>
            </h2>
            {/* <h2 className="nav__menu-item">
              <Link to="/about">About</Link>
            </h2> */}
            {/* <h2 className="nav__menu-item">
              <Link to="/events">Events</Link>
            </h2> */}
            {/* <h2 className="nav__menu-item">
              <Link to="/news">News</Link>
            </h2> */}
            {/* <h2 className="nav__menu-item">
              <Link to="/faq">FAQ</Link>
            </h2> */}
          </div>
        </div>
      </nav>
    );
  }
}

export default Nav;



// WEBPACK FOOTER //
// ./src/components/nav/nav.js